import React from 'react';

export default () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="5" fill="#F4F4F4"/>
            <path d="M14.5 9.13397C15.1667 9.51887 15.1667 10.4811 14.5 10.866L8.5 14.3301C7.83333 14.715 7 14.2339 7 13.4641V6.5359C7 5.7661 7.83333 5.28497 8.5 5.66987L14.5 9.13397Z" fill="#1A1A1A"/>
        </svg>
    );
};
